document.addEventListener('DOMContentLoaded', function () {
    //// CAROUSELS START ////
    // Initialize Flickity for .js-carousel-product
    var flktyProduct = new Flickity(".js-carousel-product", {
        pageDots: false,
        lazyLoad: true,
        fullscreen: true,
        selectedAttraction: 0.2,
        friction: 0.8,
    });

    // Initialize Flickity for .js-carousel-nav
    var flktyNav = new Flickity(".js-carousel-nav", {
        asNavFor: ".js-carousel-product",
        contain: true,
        pageDots: false,
        lazyLoad: 5,
        selectedAttraction: 0.2,
        prevNextButtons: false,
        friction: 0.8,
    });

    // prefix each alt tag to prevent redundancy with product name and help accessibility score
    const ProductCarouselcontainer = document.querySelector(".js-carousel-product"); // Use querySelector for a single instance
    if (ProductCarouselcontainer) {
        const images = ProductCarouselcontainer.querySelectorAll("img"); // Still use querySelectorAll for multiple images
        images.forEach((img, index) => {
            img.alt = `Product Photo ${index + 1} ${img.alt}`; // Update alt text
        });
    }
    const NavCarouselcontainer = document.querySelector(".js-carousel-nav"); // Use querySelector for a single instance
    if (NavCarouselcontainer) {
        const images = NavCarouselcontainer.querySelectorAll("img"); // Still use querySelectorAll for multiple images
        images.forEach((img, index) => {
            img.alt = `Thumbnail Photo ${index + 1} ${img.alt}`; // Update alt text
        });
    }

    // use fallback image for full screen view
    flktyProduct.on('fullscreenChange', (isFullscreen) => {
        const productCarousel = document.querySelector('.js-carousel-product');
        const pictureElements = productCarousel.querySelectorAll('.js-carousel-product picture');

        // get all picture tags
        pictureElements.forEach(picture => {
            const sources = picture.querySelectorAll('source');
            const img = picture.querySelector('img');
            // save current source srcset as data-original-src
            // set all <source> to the fallback image source
            if (isFullscreen) {
                sources.forEach(source => {
                    source.setAttribute('data-original-src', source.getAttribute('srcset'));
                    source.setAttribute('srcset', img.src);
                });
                // remove fixed dimensions so image fills the fullscreen container
                img.setAttribute('data-original-width', img.getAttribute('width'));
                img.setAttribute('data-original-height', img.getAttribute('height'));
                img.removeAttribute('width');
                img.removeAttribute('height');
            } else {
                // when not in fullscreen mode, set source srcset back to original url
                sources.forEach(source => {
                    const originalSrcImg = source.getAttribute('data-original-src');
                    if (originalSrcImg) {
                        source.setAttribute('srcset', originalSrcImg)
                    }
                });
                // restore original fixed dimensions for carousel view
                const origWidth = img.getAttribute('data-original-width');
                const origHeight = img.getAttribute('data-original-height');
                if (origWidth) img.setAttribute('width', origWidth);
                if (origHeight) img.setAttribute('height', origHeight);
            }
        });
    });

    // Functionality For Multiple Expandable 'Found In Cateogries' Lists

    // Select all toggle buttons within the category groups
    const toggleButtons = document.querySelectorAll(".js-category-group .toggle-button");

    // Attach click event listener to each toggle button
    toggleButtons.forEach((button) => {
        button.addEventListener("click", () => toggleCategoryList(button));
    });

    function toggleCategoryList(button) {
        // Find the closest category group and its additional list
        const group = button.closest(".js-category-group");
        const additionalList = group.querySelector(".js-additional-list");
        const icon = button.querySelector(".bi");
        const text = button.querySelector("span:last-child");

        // Toggle the visibility of the additional list
        additionalList.classList.toggle("d-none");

        // Update icon, text, and aria-expanded attribute based on visibility
        if (additionalList.classList.contains("d-none")) {
            icon.classList.replace("bi-dash", "bi-plus");
            text.textContent = "See More";
            button.setAttribute("aria-expanded", "false");
        } else {
            icon.classList.replace("bi-plus", "bi-dash");
            text.textContent = "See Less";
            button.setAttribute("aria-expanded", "true");
        }
    }

    // Settings for matching families carousels
    // Select all elements with the class "tag-similar-carousel"
    var carousels = document.querySelectorAll(".tag-similar-carousel");

    // Function to initialize Flickity with responsive groupCells
    function initializeSimilarCarousels() {
        carousels.forEach(function (elem) {
            var groupCellsValue;

            // Check screen width and set groupCells value accordingly
            if (window.innerWidth < 575.98) {
                groupCellsValue = 2; // Show 2 slides on small screens
            } else if (window.innerWidth < 767.98) {
                groupCellsValue = 3; // Show 4 slides on medium screens
            } else if (window.innerWidth < 991.98) {
                groupCellsValue = 3; // Show 4 slides on medium screens
            } else if (window.innerWidth < 1199.98) {
                groupCellsValue = 3; // Show 4 slides on medium screens
            } else if (window.innerWidth < 1399.98) {
                groupCellsValue = 3; // Show 4 slides on medium screens
            } else {
                groupCellsValue = 5; // Show 4 slides on larger screens
            }

            // Destroy the Flickity instance if it exists
            if (elem.flickityInstance) {
                elem.flickityInstance.destroy();
            }

            // Initialize Flickity for each carousel element with responsive groupCells
            elem.flickityInstance = new Flickity(elem, {
                cellAlign: "left",
                contain: true,
                selectedAttraction: 0.2,
                friction: 0.8,
                pageDots: false,
                groupCells: groupCellsValue,
            });

            // Wait until Flickity has initialized and remove aria-hidden from cells
            setTimeout(function () {
                var cells = elem.querySelectorAll(".tag-carousel-cell");
                cells.forEach(function (cell) {
                    cell.removeAttribute("aria-hidden");
                });
            }, 100);
        });
    }

    // Initialize Flickity for home carousels on page load
    initializeSimilarCarousels();

    // Reinitialize Flickity for home carousels on window resize
    window.addEventListener("resize", function () {
        initializeSimilarCarousels();
    });

    // prefix each alt tag to prevent redundency with product name and help accessibilty score
    const carouselContainers = document.querySelectorAll(".tag-similar-carousel");
    carouselContainers.forEach((container) => {
        const images = container.querySelectorAll("img");
        images.forEach((img, index) => {
            img.alt = `Photo ${index + 1} ${img.alt}`;
        });
    });
    //// CAROUSELS END ////

    //// PRINT PAGE BUTTON START ////
    document.getElementById('js-product-print-btn').addEventListener('click', () => {
        window.print();
    });
    //// PRINT PAGE BUTTON END ////

    //// FREE SAMPLE BUTTON START ////
    const freeSampleBtn = document.getElementById('js-free-sample-btn');
    const freeSampleModal = document.getElementById('sampleBasketModal');
    const bootstrapModal = new bootstrap.Modal(freeSampleModal);

    if (freeSampleBtn) {
        freeSampleBtn.addEventListener('click', async () => {
            // Do form post of the cobrand product id
            const cbpid = document.querySelector('input[name="cbpid"]')
                ? document.querySelector('input[name="cbpid"]').value
                : "";
            const url = '/api/samplebasket/add/' + cbpid;
            const response = await fetch(url, {
                method: 'POST'
            });
            if (response.ok) {
                const count = await response.text();
                const countText = count > 0 ? '(' + count + ')' : '';
                document.querySelectorAll('.js-sampleBasketCount')
                    .forEach(el => el.textContent = countText);
            }
            bootstrapModal.show();
        });
    }

    //// FREE SAMPLE BUTTON END ////

    //// OFFCANVAS QUOTE AND PROOF FORMS START ////
    const offcanvasContent = document.getElementById("js-offcanvas-body");
    // validation variable
    let v;

    function loadValidationScripts() {
        let script1;
        // Check if script is already loaded in the DOM
        // prevent script from loading multiple times
        const existingScript = document.querySelector('script[src="/lib/asp-client-validation/aspnet-validation.min.js"]');
        if (!existingScript) {
            // Load external script
            script1 = document.createElement("script");
            script1.src = "/lib/asp-client-validation/aspnet-validation.min.js";
            script1.onload = function () {
                /// initialize validation
                v = new aspnetValidation.ValidationService();
                v.ValidationInputCssClassName = 'is-invalid';
                v.ValidationMessageCssClassName = 'invalid-feedback';
                v.bootstrap({ watch: true });
            };

            // Append to the document
            document.body.appendChild(script1);
        } else {
            /// initialize validation
            if (v) return;
            v = new aspnetValidation.ValidationService();
            v.ValidationInputCssClassName = 'is-invalid';
            v.ValidationMessageCssClassName = 'invalid-feedback';
            v.bootstrap({ watch: true });
        }
    }


    async function getOffcanvasContent(form) {
        const cpbid = document.querySelector('input[name="cbpid"]')
            ? document.querySelector('input[name="cbpid"]').value
            : "";

        const cbpSku = document.querySelector('input[name="cbpSku"]')
            ? document.querySelector('input[name="cbpSku"]').value
            : "";

        const fetchUrl = `/partial/${form}?item=${cpbid}&sku=${cbpSku}`;

        if (offcanvasContent) {
            try {
                const response = await fetch(fetchUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.text();
                offcanvasContent.innerHTML = data;

            } catch (error) {
                console.error('Error fetching HTML:', error);
            }
        }
    }

    // The quote/proof form partials are injected via innerHTML, so the Cloudflare Turnstile
    // <script> tags inside them never execute. Render the widget explicitly via the shared loader
    // (window.pnowTurnstile, defined in footer.js). No-op when Turnstile is disabled (DEBUG builds
    // render no .cf-turnstile element).
    function initTurnstile(formId) {
        const form = document.getElementById(formId);
        if (!form) return;
        const widget = form.querySelector('.cf-turnstile');
        if (!widget) return;
        const tokenInput = form.querySelector('#turnstile-token');
        window.pnowTurnstile.render(widget, function (token) {
            if (tokenInput) tokenInput.value = token;
        });
    }

    document.querySelectorAll("[data-bs-toggle='offcanvas'][data-form='quote'], [data-bs-toggle='offcanvas'][data-form='proof']")
        .forEach(button => {
            button.addEventListener("click",async function () {
                let form = this.getAttribute("data-form");

                // add loading spinner
                offcanvasContent.innerHTML = '<div class="d-flex justify-content-center my-5 tag-text-theme-primary">\n' +
                    '                                <div class="spinner-border" role="status">\n' +
                    '                                    <span class="visually-hidden">Loading...</span>\n' +
                    '                                </div>\n' +
                    '                            </div>';
                if (form === "quote") {
                    await getOffcanvasContent('requestquote');
                    loadValidationScripts();
                    initTurnstile('requestQuoteForm');
                } else if (form === "proof") {
                    await getOffcanvasContent('requestproof');
                    loadValidationScripts();
                    initTurnstile('requestProofForm');
                } else {
                    offcanvasContent.innerHTML = "Something went wrong. Please try again later.";
                }
            });
        });

    // Offcanvas form container
    const formContainer = document.getElementById('js-offcanvas-body');

    // File upload functions
    const allowedExtensions = [
        'ai', 'bmp', 'doc', 'docx', 'emf', 'eps', 'gif',
        'jpeg', 'jpg', 'pdf', 'png', 'ppt', 'pptx', 'psd',
        'pub', 'svg', 'tif', 'tiff', 'wmf'
    ];
    const maxFileSize = 20000 * 1024; // 20000 KB

    // Get element references for forms when they are loaded
    function getElements() {
        return {
            fileInput: document.getElementById('js-upload-file-form-input'),
            uploadAlert: document.getElementById('js-uploadFileAlert'),
            uploadFeedback: document.getElementById('js-uploadFileFeedback'),
            removeBtn: document.getElementById('js-removeFileBtn')
        };
    }

    function showAlert(message, uploadFeedback, uploadAlert) {
        uploadFeedback.textContent = message;
        uploadAlert.style.display = 'block';
    }

    function hideAlert(uploadAlert) {
        uploadAlert.style.display = 'none';
    }

    function resetFileInput(fileInput, removeBtn, uploadAlert) {
        fileInput.classList.remove('is-invalid', 'is-valid');
        removeBtn.style.display = 'none';
        uploadAlert.style.display = 'none';
    }

    function removeFile() {
        const { fileInput, removeBtn, uploadAlert } = getElements();
        if (fileInput) {
            fileInput.value = '';
            fileInput.classList.remove('is-invalid', 'is-valid');
        }
        if (removeBtn) removeBtn.style.display = 'none';
        if (uploadAlert) uploadAlert.style.display = 'none';
    }

    // Validate file on change
    formContainer.addEventListener('change', (event) => {
        if (event.target && event.target.id === "js-upload-file-form-input") {
            const elements = getElements();
            if (!elements.fileInput || event.target !== elements.fileInput) return;

            const { fileInput, uploadAlert, uploadFeedback, removeBtn } = elements;

            resetFileInput(fileInput, removeBtn, uploadAlert);
            hideAlert(uploadAlert);

            if (fileInput.files.length === 0) {
                showAlert('Please select a file.', uploadFeedback, uploadAlert);
                fileInput.classList.add('is-invalid');
                return;
            }

            const file = fileInput.files[0];
            const fileSize = file.size;
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!allowedExtensions.includes(fileExtension)) {
                showAlert(`Only ${allowedExtensions.join(', ')} are supported.`, uploadFeedback, uploadAlert);
                fileInput.classList.add('is-invalid');
                return;
            }

            if (fileSize > maxFileSize) {
                showAlert('File size exceeds the 20000 KB limit.', uploadFeedback, uploadAlert);
                fileInput.classList.add('is-invalid');
                return;
            }

            // If valid
            removeBtn.style.display = 'inline-block';
        }
    });

    // Remove file button from input file
    formContainer.addEventListener('click', (event) => {
        if (event.target && event.target.id === "js-removeFileBtn") {
            const elements = getElements();
            if (event.target === elements.removeBtn) {
                removeFile();
                hideAlert(elements.uploadAlert);
            }
        }
    });

    // check for validation errors
    formContainer.addEventListener('click', (event) => {
        const fileUploadAlert = document.getElementById('js-uploadFileAlert');

        if (event.target && event.target.id === "requestProofBtn") {
            // event.preventDefault();
            if (!v.isValid(document.getElementById('requestProofForm'))) {
                // set delay for scroll to wait for item to be visible
                setTimeout(() => {
                    document.querySelector('.tag-request-validation-form').scrollIntoView({ behavior: "smooth", block: "start" });
                }, 50);
            }
            // Check if file upload errors
            if (fileUploadAlert.style.display !== 'none') {
                fileUploadAlert.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
        if (event.target && event.target.id === "requestQuoteBtn") {
            // event.preventDefault();
            if (!v.isValid(document.getElementById('requestQuoteForm'))) {
                // set delay for scroll to wait for item to be visible
                setTimeout(() => {
                    document.querySelector('.tag-request-validation-form').scrollIntoView({ behavior: "smooth", block: "start" });
                }, 50);
            }
            // Check is file upload errors
            if (fileUploadAlert.style.display !== 'none') {
                fileUploadAlert.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    })

    // Show a submit error without destroying the form, so the user can correct and retry. Refreshes
    // the single-use Turnstile token (a spent/expired token would otherwise fail every retry).
    function showOffcanvasFormError(status) {
        const alertEl = document.querySelector('#js-offcanvas-body .tag-request-validation-form');
        let text;
        if (status === 429) {
            text = "You've made several requests recently. Please wait a moment and try again.";
        } else if (status === 400) {
            text = "We couldn't verify your submission. Please complete the verification and try again.";
        } else {
            text = "Something went wrong and your form was not submitted. Please try again.";
        }
        if (alertEl) {
            alertEl.textContent = text;
            alertEl.style.display = 'block';
            alertEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (window.turnstile && typeof window.turnstile.reset === 'function') {
            try { window.turnstile.reset(); } catch (e) { /* ignore */ }
        }
    }

    // submit request proof and request quote
    async function submitQuoteProofForm(url, formData, msg, eventName) {
        const formBody = document.getElementById('js-offcanvas-body');

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                showOffcanvasFormError(response.status);
                return;
            }

            formBody.innerHTML = msg;

            // ---- FIRE GA4/GTM EVENT *AFTER SUCCESS* ----
            pushGtmEventForProduct(eventName, {
                page_path: location.pathname + location.search
            });


        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }

    // --- Utility: push GTM/GA4 event safely ---
    function pushGtmEventForProduct(eventName, params) {
        try {
            window.dataLayer = window.dataLayer || [];
            const payload = Object.assign({ event: eventName }, params || {});
            window.dataLayer.push(payload);
        } catch (_e) {
            // swallow; analytics should never break UX
        }
    }


    formContainer.addEventListener("submit", async function (event) {
        // ignore request catalog submit
        if (event.target && event.target.id === "requestCatalogForm") {
            return;
        }

        const fileUploadAlertIsVisible = document.getElementById('js-uploadFileAlert').style.display !== 'none'

        if (event.target && event.target.id === "requestProofForm") {
            event.preventDefault();

            if (v.isValid(document.getElementById('requestProofForm')) && !fileUploadAlertIsVisible) {
                let url = '/partial/RequestProof';
                let formData = new FormData(event.target);
                let msg = '<div class="h5">Thank you for your proof request.</div><p>Your sales representative will email your proof, or any questions on your request, shortly.</p>';

                await submitQuoteProofForm(url, formData, msg, 'proof_request');
            }
        }
        if (event.target && event.target.id === "requestQuoteForm") {
            event.preventDefault();

            if (v.isValid(document.getElementById('requestQuoteForm')) && !fileUploadAlertIsVisible) {
                let url = '/partial/RequestQuote';
                let formData = new FormData(event.target);
                let msg = '<div class="h5">Thank you for your quote request.</div><p>Your sales representative will email your quote, or any questions on your request, shortly.</p>';

                await submitQuoteProofForm(url, formData, msg, 'quote_request');
            }
        }
    });
    //// OFFCANVAS QUOTE AND PROOF FORMS END ////

    //// PRODUCT VIDEO START ////
    const productVideoModal = document.getElementById('playVideo');

    // Check if product video modal exists
    if (!productVideoModal) return;

    const iframe = productVideoModal.querySelector('#js-productVideoFrame');

    // check if modal iframe exists
    if (!iframe) return;

    // open product video modal
    productVideoModal.addEventListener('show.bs.modal', function (event) {
        const button = event.relatedTarget;

        if (!button) return;

        let videoUrl = button.getAttribute('data-url');
        if (!videoUrl) return;

        // convert YouTube watch URL to embed URL
        if (videoUrl.includes('watch?v=')) {
            const videoId = videoUrl.split('watch?v=')[1].split('&')[0];
            videoUrl = `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
        }

        iframe.src = videoUrl;
    });
    
    productVideoModal.addEventListener('hidden.bs.modal', function () {
        // when modal closes stop video (remove src)
        iframe.src = '';
    });
    //// PRODUCT VIDEO END ////
});